import { categories } from "@/data/products";

type Props = {
  active: string;
  onChange: (cat: string) => void;
};

const CategoryFilter = ({ active, onChange }: Props) => {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <button
          key={cat}
          onClick={() => onChange(cat)}
          className={`px-4 py-1.5 text-xs tracking-widest uppercase border transition-colors ${
            active === cat
              ? "bg-foreground text-background border-foreground"
              : "bg-transparent text-muted-foreground border-border hover:border-foreground hover:text-foreground"
          }`}
        >
          {cat}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
